import { render, staticRenderFns } from "./purchaseContractCreation.vue?vue&type=template&id=c015cc80&scoped=true"
import script from "./purchaseContractCreation.vue?vue&type=script&lang=js"
export * from "./purchaseContractCreation.vue?vue&type=script&lang=js"
import style0 from "./purchaseContractCreation.vue?vue&type=style&index=0&id=c015cc80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c015cc80",
  null
  
)

export default component.exports